export default __webpack_public_path__ + "static/media/family-icon-active.4724ef24.svg";